import React from 'react';
import * as Yup from "yup";
import { Paper, withStyles } from '@material-ui/core';
import DeviceDataApiForm from './DeviceDataApiForm'
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/deviceDataApiActions";
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }

});

const DeviceDataApiCreate = props => {
    const { permissions, activeCustomer, translations, classes, onCreateDeviceDataApi } = props;

    const handleSubmit = async data => {
        let objectToSend = { ...data };
        let result = await onCreateDeviceDataApi({ ...objectToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        Type: "",
        Active: false,
        AppleFullData: false,
        AppleSimlockOnly: false,
        GsmaBlacklist: false,
        RecallBehavior: "on_error",
        SamsungWorldwide: false,
        MdmWork: false,
        AppleICloudLock: false,
        Autopilot: false,
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Type: Yup.string().required("Required"),
            Active: Yup.boolean().required("Required"),
            RecallBehavior: Yup.string().required("Required"),
        },
        FormTitle: translations['create_device_data_api'] || 'Create device data API',
        ButtonSubmit: hasPermission(permissions, "device_data_api_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <DeviceDataApiForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
            />
        </Paper>
    )
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateDeviceDataApi: deviceDataApi => dispatch(actions.createDeviceDataApi(deviceDataApi))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DeviceDataApiCreate));
